import { create } from "zustand";

interface ToastState {
  message: string | null;
  kind: "ok" | "bad";
  show: (message: string, kind?: "ok" | "bad") => void;
}

export const useToast = create<ToastState>((set) => ({
  message: null,
  kind: "ok",
  show: (message, kind = "ok") => {
    set({ message, kind });
    setTimeout(() => set({ message: null }), 3200);
  },
}));
